var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelVkFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#45668E",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.63 15.447s.233-.026.351-.153c.11-.118.106-.338.106-.338s-.015-1.031.463-1.183c.472-.15 1.078.997 1.72 1.438.486.333.855.26.855.26l1.717-.024s.898-.055.472-.762c-.035-.057-.248-.522-1.277-1.477-1.076-.999-.932-.837.365-2.566.79-1.053 1.105-1.695 1.007-1.97-.094-.263-.675-.193-.675-.193L15.8 8.49s-.143-.02-.25.044a.54.54 0 0 0-.17.207s-.306.815-.714 1.507c-.86 1.462-1.205 1.54-1.346 1.449-.327-.212-.245-.85-.245-1.304 0-1.416.215-2.007-.419-2.16-.21-.05-.365-.084-.902-.09-.69-.007-1.274.003-1.604.165-.22.107-.39.347-.286.361.127.017.417.078.57.287.198.27.191.875.191.875s.114 1.667-.265 1.874c-.261.142-.618-.148-1.386-1.474-.393-.68-.69-1.43-.69-1.43s-.057-.14-.16-.215c-.123-.091-.296-.12-.296-.12l-1.838.012s-.275.007-.377.127c-.09.107-.007.328-.007.328s1.438 3.364 3.067 5.06c1.493 1.555 3.19 1.453 3.19 1.453z"
}))));
export default SvgGemChannelVkFilled;